/* import __COLOCATED_TEMPLATE__ from './article-suggestions-inbox.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();